import { sidebarWidth } from '../../components/sidebar/Sidebar'
export const kioksStatusStyles = {
  content: {
    paddingTop: '50px',
    marginLeft: sidebarWidth,
    width: '100%' - sidebarWidth
  },
  btnConfig: {
    background: 'none'
  },
  btnLanguage: {
    background: 'none'
  },
  chooseCity: {
    display: 'inline'
  },
  textCities: {
    margin: '16px 20px',
    fontSize: '16px',
    display: 'inline-block',
    position: 'relative'
  },
  findField: {
    width: '98%',
    backgroundColor: '#efa817',
    margin: '10 px 0 0 0',
    border: 0,
    padding: '10px',
    color: '#fff'
  }
}
